import request from "@/utils/request";
export function loginAPI(data) {
  return request({
    url: "/student/login",
    method: "POST",
    data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
export function getCurrentUserInfo() {
  return request({
    url: "sCenter/getCurrentUserInfo",
    method: "GET",
  });
}
export function changePasswordAPI(data) {
  return request({
    url: "/sCenter/changePw",
    method: "POST",
    data,
  });
}
export function studentCheckWxBinding() {
  return request({
    url: "/sCenter/checkWxBinding",
    method: "get",
  });
}
export function wxLogin(params) {
  return request({
    url: "/wx/portal/default/loginUrl",
    method: "get",
    params,
  });
}
export function getMessageList(params) {
  return request({
    url: "/sCenter/message/list",
    method: "get",
    params,
  });
}
export function getmessageCount() {
  return request({
    url: "/sCenter/message/unread",
    method: "get",
  });
}
export function messageRead(data) {
  return request({
    url: "/sCenter/message/read",
    method: "POST",
    data,
  });
}
export function sendCaptcha(data) {
  return request({
    url: "/sCenter/open/sendCaptcha",
    method: "POST",
    data,
  });
}
export function verifyCaptcha(data) {
  return request({
    url: "/sCenter/open/verifyCaptcha",
    method: "POST",
    data,
  });
}
export function registerUser(data) {
  return request({
    url: "/sCenter/open/register",
    method: "POST",
    data,
  });
}
export function captchaLogin(data) {
  return request({
    url: "/sCenter/open/login",
    method: "POST",
    data,
  });
}
export function forgetPwd(data) {
  return request({
    url: "/sCenter/open/forgetPwd",
    method: "POST",
    data,
  });
}
export function getWxWxAccessId(params) {
  return request({
    url: "sCenter/storeWxAccessId",
    method: "get",
    params,
  });
}
export function unBindWx(data) {
  return request({
    url: "sCenter/removeWxAccessId",
    method: "put",
    data,
  });
}
export function getWxLoginUrl(params) {
  return request({
    url: "/wx/portal/default/loginUrl",
    method: "get",
    params,
  });
}
export function getWxLoginCode(params) {
  return request({
    url: "/wx/login/default/code",
    method: "get",
    params,
  });
}
